<template>
    <CampaignActionsDropdown  v-if="params.data && params.data.version === 'v3'" :campaign="params.data" />
    <span v-else class="review-buttons cursor-not-allowed text-gray-400">
        Campaign Archived
    </span>
</template>

<script>
import CampaignActionsDropdown from '@/views/campaigns/index/components/CampaignActionsDropdown.vue'

export default {
  components : {
    CampaignActionsDropdown
  }
}
</script>
